import script from "./footerLogos.vue?vue&type=script&setup=true&lang=js"
export * from "./footerLogos.vue?vue&type=script&setup=true&lang=js"

import "./footerLogos.vue?vue&type=style&index=0&id=e297e9a4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e297e9a4"]])

export default __exports__